import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const TextHeader = styled('div')`
  h1 {
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  }
  p:last-child {
    margin-top: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const BreadcrumbWrapper = styled('div')`
  opacity: 0.5;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  > ul {
    display: inline-block;
  }
  > * {
    ${({ theme }) => theme.typography.xSmall};
  }
`;

export const DividendCTA = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  background: ${({ theme }) => theme.color.noir};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  height: ${({ theme }) => theme.x5spacePx}px;
  ${({ theme }) => theme.typography.xSmall};
`;
